/**
 * Converts a DCC brand feature scope to the brand letter used by E3D and in dealer IDs
 * @param brand - DCC brand (e.g., 'audi', 'vw')
 * @returns brand letter (e.g., 'A', 'V') or 'A' as fallback
 */
export const mapBrandToE3D = (brand: string): string => {
    const brandMap: Record<string, string> = {
        audi: 'A',
        vw: 'V',
        seat: 'S',
        skoda: 'C',
        bentley: 'E',
        lamborghini: 'L',
        man: 'M',
        vwn: 'N',
        porsche: 'P',
        cupra: 'S',
    }
    return brandMap[brand.toLowerCase()] || 'A'
}
